<template>
	<form id="signup-form" class="signup-form" method="post" @submit.prevent="submit">
		<h3 class="mb-5">{{ desc }}<small class="ml-2">not working!</small></h3>
		<div class="form-group d-flex justify-content-between" :class="{opacity: !show_textArea}">
			<!-- name -->
			<div class="field mr-2">
				<label class="label" :class="{ 'to_top': !name_up }">name</label>
				<input type="text" class="input" required v-model="name_input" @focus="name_up = !name_up" @blur="name_up = true">
			</div>
			<!-- email -->
			<div class="field">
				<label class="label" :class="{ 'to_top': !email_up }">e-mail</label>
				<input type="e-mail" class="input" required v-model="email.value" @focus="email_up = !email_up" @blur="email_up = true">
			</div>
		</div>
		<div class="textArea d-flex">
			<textarea name="text" v-model="message"></textarea>
			<!-- submit button -->
			<div class="field">
				<button type="submit" class="form-button" name="submit">
					<i class="fas fa-arrow-alt-circle-right"></i>	
				</button>
			</div>
		</div>
	</form>
</template>

<script>
import axios from 'axios'
export default {
	data () {
	    return {
	      	desc: 'Write to me',
			name_up: true,
			email_up: true,
			show_textArea: true,
			name_input: 'Full name',
			email: {
				value: "jo@hnd.oe",
				valid: true
			},
			message: 'Your message',
			submitted: false
	    }
	},
	methods: {
		submit(evt) {
			evt.preventDefault();

			this.isSending = true;

			setTimeout(() => {
				// Build for data
				let form = new FormData();
				for (let field in this.contact) {
					form.append(field, this.contact[field]);
				}

				// Send form to server	
				this.$http('../assets/php/submit.php', form).then((response) => {
					console.log(response);
					this.clearForm();
					this.isSending = false;
				}).catch((e) => {
					console.log(e)
				});

			}, 1000);
		},
		validate: function(type, value) {
			if (type === "email") {
				this.email.valid = this.isEmail(value) ? true : false;
			}
		},
		isEmail: function (value) {
			var emailRegExp = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
			
			return emailRegExp.test(value)
		}
	},
	watch: {
		// watching nested property
		"email.value": function(value) {
			this.validate("email", value);
		}
	}
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
$dark: #2c3e50
$orange: #FF6700
h1, h2
	color: $dark
	font-weight: normal
	margin: 30px 0 40px
p
	font-size: 27.5pt
</style>



// WEBPACK FOOTER //
// src/components/Form.vue